import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useProjectStore } from "@/stores/project";
import { useProject } from "@/api/hooks";

/**
 * Hook that reads projectId from the URL params and keeps the
 * project store in sync. Returns the projectId and project data.
 */
export function useCurrentProject() {
  const { projectId } = useParams<{ projectId: string }>();
  const selectProject = useProjectStore((s) => s.selectProject);
  const storedId = useProjectStore((s) => s.selectedProjectId);
  const storedName = useProjectStore((s) => s.selectedProjectName);

  const { data: project, isLoading, error } = useProject(projectId ?? "");

  // Keep store in sync with URL
  useEffect(() => {
    if (project && projectId) {
      selectProject(project.id, project.name);
    }
  }, [project, projectId, selectProject]);

  return {
    projectId: projectId ?? storedId ?? "",
    projectName: project?.name ?? storedName ?? "",
    project: project ?? null,
    isLoading,
    error,
  };
}
